import React from 'react';
import './BuyerTypeFilter.scss';

const BuyerTypeFilter = ({ selectedType, onTypeChange }) => {
  const buyerTypes = [
    { id: 'all', label: 'All' },
    { id: 'retailer', label: 'Retailer' },
    { id: 'distributor', label: 'Distributor' },
    { id: 'bar', label: 'Bar' },
    { id: 'restaurant', label: 'Restaurant' }
  ];

  return (
    <div className="buyer-type-filter">
      {buyerTypes.map(type => (
        <button
          key={type.id}
          className={`buyer-type-filter__btn ${selectedType === type.id ? 'active' : ''}`}
          onClick={() => onTypeChange(type.id)}
        >
          {type.label}
        </button>
      ))}
    </div>
  );
};

export default BuyerTypeFilter;
